import { types, query } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const locationStockInitQuery = gql`
  ${query({
    locations: [
      {
        id: types.string,
        name: types.string,
        inventory_restock_type: types.string,
      },
    ],
  })}
`;
